export default "__VITE_ASSET__u7K$ajvLf3eL0A5ibt$nLA__"